import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { apiUrl } from 'utils/apiUrl';
import { ExecutionListView } from 'components/JobExecutionList/ExecutionListView';

export const GlobalJobExecutions: React.FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <ExecutionListView
      apiPath={apiUrl('lct', 'tenants/global/jobManager/executions')}
      title={t('jobService.executionPageTitle')}
      testIdPrefix="global-job-executions"
    />
  );
};

export default GlobalJobExecutions;
